import React from "react";
import PropTypes from "prop-types";
import WideHeader from "./wide-header/WideHeader";
import ModalHeader from "./modal-header/ModalHeader";
import appPath from "utils/appPath";

interface HeaderProps {
    title: string;
    closeable?: boolean;
    children: JSX.Element | JSX.Element[];
}

const Header = ({ title, closeable, children }: HeaderProps): JSX.Element => {
    if (appPath.isIframePath()) {
        return (
            <ModalHeader title={ title } closeable={ closeable }>
                { children }
            </ModalHeader>
        );
    }

    return (
        <WideHeader title={ title }>
            { children }
        </WideHeader>
    );
};

Header.propTypes = {
    title: PropTypes.string,
    closeable: PropTypes.bool
};

export default Header;
